<template>

	<v-content>
		<v-container fluid fill-height>

			<div class="TeklifSettings" v-if="isLoading">
				<div class="text-xs-center pa-5">
					<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
					<div class="caption mt-4">İşlem devam ediyor</div>
				</div>
			</div>

			<div class="TeklifSettings" v-if="!isLoading">
				<div class="TeklifSettingsTitle"> 
					<span>Ayarlar</span> 
					<div class="TeklifSettingsActions">
						<v-btn outline color="success" dark @click="saveSettings()" >
							<v-icon left>save</v-icon>
								Kaydet
						</v-btn> 
					</div>
				</div>
				<div class="TeklifSettingsBody">

					<v-layout row wrap>   
						<v-flex xs12>
							<label><b>Ticari Koşullar</b></label>
							<ckeditor :editor="editor" v-model="settings.ticari_kosullar" :config="editorConfig"></ckeditor>
						</v-flex>

						<v-flex xs12>
							<v-divider class="mt-4 mb-4"></v-divider>
						</v-flex>
						<v-flex xs12>
							<label><b>Referanslar</b></label>
							<vue-amiral-imagelist v-model="settings.referanslar" mediagroup="teklif_referanslar" limit="100" sizetype="hvs" /> 
						</v-flex>

					</v-layout>

				</div>
			</div>

		</v-container>
	</v-content>


</template>


<script>
	 
	import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
	export default {
		name: "TeklifSettings",
		components: { 
		},
		data() {
			return {
				isLoading: true, 
				settings : {
					ticari_kosullar : "",
					referanslar : []
				},

				editor: ClassicEditor,
				editorConfig: { }
			}
		},
		watch: {
			  
		},
		mounted() {
			this.isLoading = true;
			this.loadSettings();  
		},
		methods: {
			loadSettings() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/settings/", {
					params: {}
				}).then(response => {
					var s = response.body;
					Object.keys(s).map((k) => { 
						this.settings[k] = s[k]
					}) 
					this.isLoading = false;
				})
			},  
			saveSettings() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/settings/save", this.settings, {
					params: {}
				}).then(response => {   
					this.loadSettings();
				})
			},
		   
		},
		computed: {
			 
		}
	}
</script>

<style lang="less">
	.tekifEditCustomerBox{
		.tekifEditCustomerCompany{ 
		}
		.tekifEditCustomerFullname{
			font-size: 12px;
			margin-left:10px;
			color:#aaa;
			line-height: 24px; 
		}
	}
	.TeklifSettings {
		width: 100%;
		background-color: #fff;
		box-shadow: 0 0 3px rgb(107, 107, 107);
		
		.TeklifSettingsTitle {
			border-bottom: 2px solid #ccc;
			font-weight: 700;
			padding: 20px;
			position: relative;

			.TeklifSettingsActions {
				position: absolute;
				right: 2px;
				top: 6px;

				.v-btn {
					padding: 0 10px;

					.v-icon {
						margin-right: 3px;
					}
				}

				.listitem {
					&:hover {
						color: #ccc;
						cursor: pointer;
					}
				}
			}
		}

		.TeklifSettingsBody {
			padding: 20px;
			  
		}
	}
</style>